import { Card, CardBody } from '@/components/ui/Card';
import { Construction } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
  phase: string;
}

/** Used for any nav link that doesn't have a real page yet. */
export function PlaceholderPage({ title, phase }: PlaceholderPageProps) {
  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-6 text-2xl font-semibold text-brand-charcoal">{title}</h1>
      <Card>
        <CardBody>
          <div className="flex items-start gap-3 text-brand-gray-mid">
            <Construction className="h-5 w-5 shrink-0 text-brand-warning" aria-hidden />
            <div className="text-sm">
              <p className="font-medium text-brand-charcoal">Coming in {phase}</p>
              <p className="mt-1">
                This page is scaffolded but the feature itself ships in a later phase.
              </p>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
